import { render, staticRenderFns } from "./columnedit.vue?vue&type=template&id=31cb8142&scoped=true&"
import script from "./columnedit.vue?vue&type=script&lang=js&"
export * from "./columnedit.vue?vue&type=script&lang=js&"
import style0 from "./columnedit.vue?vue&type=style&index=0&id=31cb8142&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cb8142",
  null
  
)

component.options.__file = "columnedit.vue"
export default component.exports